import { P2GBox } from '@parcel2go/core-ui';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { CoverExtra } from '~/lib/consts/extras';
import { ExtrasToggle } from './ItemExtrasToggle';
import { useMemo } from 'react';
import { HiddenExtras, ProtectionExtraIds } from '../../ExtrasHelper';

interface props {
  item: SmartSendItemApiModel;
}

const hidden = [...HiddenExtras, ...ProtectionExtraIds];

export default function BookedItemExtras({ item }: props) {
  const extras = useMemo(() => {
    const output = (item.Extras?.filter((x) => !hidden.includes(x.Id)) || []).map((x) => ({
      ...x,
      Included: true,
      Available: true,
      Selected: true
    }));

    // There are multiple types so show standard protection icon.
    const hasProtection = item.Extras?.some((x) => ProtectionExtraIds.includes(x.Id)) || false;
    output.push({
      Id: CoverExtra,
      Name: 'Protection',
      Included: hasProtection,
      Available: hasProtection,
      Selected: hasProtection
    });

    return output;
  }, [item.Extras]);

  return (
    <P2GBox display="flex" alignItems="center" gap={0.5}>
      {extras.map((e) => (
        <P2GBox pl={1} key={e.Id}>
          <ExtrasToggle e={e} selected={e.Selected} />
        </P2GBox>
      ))}
    </P2GBox>
  );
}
